import {MainPageConfig} from "@/interfaces/main-page.interface";

class DataSource {
  setBlocksTypes( data ) {
    data.content.map( ( block: any ) => {
      if (block['combi_player']) {
        block.type = MainPageConfig.PageBlockTypes.COMBI_PLAYER;
        block.showInScrollNav = Boolean(Number(block['combi_player'].show_in_scroll_nav));
      }
      else if (block['quote']) {
        block.type = MainPageConfig.PageBlockTypes.QUOTE;
        block.showInScrollNav = Boolean(Number(block['quote'].show_in_scroll_nav));
      }
      else if (block['films']) {
        block.type = MainPageConfig.PageBlockTypes.FILMS;
        block.showInScrollNav = Boolean(Number(block['films'].show_in_scroll_nav));
      }
      else if (block['custom_video']) {
        block.type = MainPageConfig.PageBlockTypes.CUSTOM_VIDEO;
        block.showInScrollNav = Boolean(Number(block['custom_video'].show_in_scroll_nav));
      }
      else if (block['gallery']) {
        block.type = MainPageConfig.PageBlockTypes.GALLERY;
        block.showInScrollNav = Boolean(Number(block['gallery'].show_in_scroll_nav));
      }
      else if (block['image']) {
        block.type = MainPageConfig.PageBlockTypes.IMAGE;
        block.showInScrollNav = Boolean(Number(block['image'].show_in_scroll_nav));
      }
      else if (block['text']) {
        block.type = MainPageConfig.PageBlockTypes.TEXT;
        block.showInScrollNav = Boolean(Number(block['text'].show_in_scroll_nav));
      }
      else if (block['film_playlist']) {
        block.type = MainPageConfig.PageBlockTypes.FILMS_PLAYLIST;
        block.showInScrollNav = Boolean(Number(block['film_playlist'].show_in_scroll_nav));
      }
      else if (block['sponsors']) {
        block.type = MainPageConfig.PageBlockTypes.SPONSORS;
        block.showInScrollNav = Boolean(Number(block.sponsors.show_in_scroll_nav));
        const list = [];
        for (let key in block.sponsors.sponsors) {
          list.push({
            id: key,
            ...block.sponsors.sponsors[key]
          });
        }
        block['sponsors'] = list;
      }
      else if (block['themes']) {
        block.type = MainPageConfig.PageBlockTypes.THEMES;
        block.showInScrollNav = Boolean(Number(block['themes'].show_in_scroll_nav));
        const list = [];
        for (const theme in block['themes']['themes']) {
          list.push(
            {
              ...block['themes']['themes'][theme]
            }
          )
        }
        block['themes']['themes'] = list;
      }
      else if (block['keyWords']) {
        block.type = MainPageConfig.PageBlockTypes.KEYWORDS;
        block.showInScrollNav = Boolean(Number(block['keyWords'].show_in_scroll_nav));
        const list = [];
        for (const word in block['keyWords']['words']) {
          list.push(
            {
              entity_id: block['keyWords']['words'][word].tid,
              keyword: block['keyWords']['words'][word].name,
              ...block['keyWords']['words'][word]
            }
          )
        }
        block['keyWords']['words'] = list;
      }

      return block
    });

    data.content = data.content.filter( (block) => !!block.type )

    return data;
  }
}

export const contentPagesDataSource = new DataSource();
